import { dispatchEvent } from '../shared/events';

class _Controller {

  constructor($limits, $saveToList, $lists) {
    this.$saveToList = $saveToList;
    this.$limits = $limits;
    this.$lists = $lists;
  }

  async newTrack(collection) {

    await this.$lists.initialize();

    const incrementOnDomain = (sum, list) => sum + (list.domain ? 1 : 0);
    const rankingListsUsed = this.$lists.lists.reduce(incrementOnDomain, 0);
    const rankingListsAvailable = Math.max(this.$limits.raw.ranking_lists - rankingListsUsed, 0);

    if (rankingListsAvailable < 1) {
      return dispatchEvent('triedToExceedRankingLists', {requested: rankingListsUsed + 1});
    };

    this.$saveToList.newTrack(collection, this.domain, this.country);

  }

  clickedDisabledCreateRankingList() {
    dispatchEvent('clickedCreateRankingList');
  }

}

_Controller.$inject = ['$limits', '$saveToList', '$lists'];

export const trackButton = {
  bindings: {
    collection: '<',
    country: '<',
    domain: '<'
  },
  controller: _Controller,
  template: `
    <button class='track' ng-show='$ctrl.$limits.cant("ranking")' ng-click='$ctrl.clickedDisabledCreateRankingList()'><i class='fa-solid fa-chart-line'></i> Track...</button>
    <button class='track' ng-show='$ctrl.$limits.can("ranking")' ng-click='$ctrl.newTrack($ctrl.collection)' ng-disabled='!$ctrl.collection.keywords || $ctrl.collection.keywords && ($ctrl.collection.getActionable().length < 1)'><i class='fa-solid fa-chart-line'></i> Track...</button>
  `
}